"use strict";
exports.__esModule = true;
exports.chart_area_data_Fill = {
  "name": "--pf-chart-area--data--Fill",
  "value": "#151515",
  "var": "var(--pf-chart-area--data--Fill, #151515)"
};
exports["default"] = exports.chart_area_data_Fill;